import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { downloadFile } from "../../Utils/downloadFile";
import { parseApiError } from "@yooink/youtils/es/ParseApiError";
import { toast } from "react-toastify";
import { LegacySelect, optionsFromObject } from '@yooink/youi/dist/LegacySelect';
import FormGroup from "reactstrap/es/FormGroup";
import Label from "reactstrap/es/Label";
import Button from "reactstrap/es/Button";
import MenuManager from "@yooink/youtils/es/MenuManager";
import { FaMailBulk } from "react-icons/fa";
import { Block } from '@yooink/youi/dist/Layout/Block';
import { Header } from '@yooink/youi/dist/Layout/Header';
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
MenuManager.RegisterItem({
    path: '/mailingList',
    name: 'Списки рассылок',
    icon: _jsx(FaMailBulk, {}),
    acl: 'users',
    position: 10
});
export function MailingListPage() {
    const [ch, setChanel] = useState('news');
    const [format, setFormat] = useState('csv');
    const [disabled, setDisabled] = useState(false);
    function download() {
        setDisabled(true);
        downloadFile(`/api/v2/mailingLists/export`, `Список email для рассылки.${format}`, {
            params: {
                format,
                channel: ch
            }
        })
            .catch(err => toast.error(parseApiError(err)))
            .finally(() => setDisabled(false));
    }
    return (_jsxs(Block, { children: [_jsx(Header, { title: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438" }), _jsx(Row, { children: _jsxs(Col, Object.assign({ sm: { size: 4, offset: 0 } }, { children: [_jsxs(FormGroup, { children: [_jsx(Label, { children: "\u041A\u0430\u043D\u0430\u043B \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438" }), _jsx(LegacySelect, { options: optionsFromObject({
                                        news: 'Рассылка на новости (Зарегистрированные и анонимные пользователи)',
                                        any: 'Любой (Только анонимные пользователи)'
                                    }), value: ch, onChange: e => setChanel(e.value) })] }), _jsxs(FormGroup, { children: [_jsx(Label, { children: "\u0424\u043E\u0440\u043C\u0430\u0442" }), _jsx(LegacySelect, { options: optionsFromObject({
                                        csv: 'csv (Разделитель точка с запятой ";")',
                                    }), value: format, onChange: e => setFormat(e.value) })] }), _jsx(Button, Object.assign({ color: 'success', disabled: disabled, onClick: download }, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C" }))] })) })] }));
}
